import React from 'react';

const Close = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 14 14" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path id="Close_a" d="M445.25 183l-5.25 5.25-5.25-5.25-1.75 1.75 5.25 5.25-5.25 5.25 1.75 1.75 5.25-5.25 5.25 5.25 1.75-1.75-5.25-5.25 5.25-5.25z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Close_a" transform="translate(-433 -183)" />
  </svg>
);

export default Close;



// WEBPACK FOOTER //
// ./src/common/icons/Close.js